import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group'

import './Hero.css'

function Hero({title, subtitle}) {

    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true)
    }, [])

    function scroll() {
        window.scrollTo(0, 600)
    }

    return (
        <div className="hero">

            <div className="text-box">
                
                <h1 className="heading-primary">
                    <CSSTransition in={loaded} timeout={500} classNames="heading-primary-main">
                        <span className="heading-primary-main">{title || "Footgrail"}</span>
                    </CSSTransition>
                    <span className="heading-primary-sub">{subtitle || "Fotballstatistikk"}</span>
                </h1>
                
                <Link onClick={scroll} className="button button-white button-animated">Les mer</Link>

            </div>
        </div>
    )
}
export default Hero